import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please provide a first name' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please provide a last name' },
      ]
      },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
      },
    addressline1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please provide an event date' },
      ]
          },
    starttime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    endtime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    operation: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
       },
    plannedguestcount: {
      validations: [
        { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    sitename: {
      validations: [       
      { type: 'required', message: 'Please fill in required field.' }
    ]
    },
    reference: {
      validations: [
       { type: 'required', message: 'Please fill in required field.' }
      ]
      },
    Description: {
      validations: [
       { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Let\'s Create Your Perfect Event! Tell Us About Your Vision',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
         }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:*',
            mapping: 'addressline1'
           }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'city'
           }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'State:*',
            mapping: 'state'
         }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:*',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventdate'
         }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:*',
            options: [
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
            ],
            mapping: 'starttime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event End Time:*',
            options: [
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
            ],
            mapping: 'endtime'
          }
        ]
      },
      {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Date Flexible?:*',
          options: [
            {label: 'Date Flexible - Yes' , value: 'Date Flexible - Yes'},
            {label: 'Date Flexible - No' , value: 'Date Flexible - No'},
          ],
          mapping: 'operation'
        }
      ]
    },
      {
        fields: [
          {
              type: 'text',
              size: 'Medium',
              label: 'Estimated Guest Count:*',
              mapping: 'plannedguestcount'
           }
        ]
      },
      {
            fields: [
              {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Event Type:*',
                    options: [
                      { label: 'Wedding'  , value: 'Wedding'},
                      { label: 'Corporate'  , value: 'Corporate'},
                      { label: 'Private Dinner'  , value: 'Private Dinner'},  
                      { label: 'Celebration'  , value: 'Celebration'},  
                      { label: 'Other'  , value: 'Other'},                  
                    ],
                    mapping: 'theme'
                 }
        ]
      },
      {
        fields: [
          {
                type: 'text',
                size: 'Medium',
                label: 'Venue/Location Name:*',
                mapping: 'sitename'
              }
            ]
          },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Budget:*',
            options:[
              { label: '$5k to 10K'  , value: '$5k to 10K'},
              { label: '$10K to 25K'  , value: '$10K to 25K'},
              { label: '$25K & above'  , value: '$25K & above'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Menu Type:*',
            options:[
              { label: 'Breakfast'  , value: 'Breakfast'},
              { label: 'Plated Lunch'  , value: 'Plated Lunch'},
              { label: 'Lunch Buffet'  , value: 'Lunch Buffet'},
              { label: 'Reception'  , value: 'Reception'},
              { label: 'Plated Dinner'  , value: 'Plated Dinner'},
              { label: 'Dinner Buffet'  , value: 'Dinner Buffet'},
              { label: 'Dinner Stations'  , value: 'Dinner Stations'},
              { label: 'Undecided'  , value: 'Undecided'},
              { label: 'N/A'  , value: 'N/A'},
            ],
            mapping: 'Description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Would you like information about Bold Design/Floral? Any Additional Details about your event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Bold American Catering Contact Form',
    formId: '2244',
    clientKey: 'C9595AA1-EB2C-4EFD-AEF4-A1F75DBAE585',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you for sharing your vision with us! We will review your details and reach out shortly to begin planning your unforgettable event.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
